import { RoomDto, RoomUnitDto } from 'actions/rooms/RoomsDtos';
import { parseJSON } from 'utils/json';
import { Room, RoomRule, RoomRuleData, RoomUnit } from 'types/Room';

export const convertToRoom = (roomDto: RoomDto): Room => {
    return {
        id: roomDto.id,
        uuid: roomDto.uuid,
        name: roomDto.name,
        description: roomDto.description,
        photos: roomDto.photos.map(photo => photo.url),
        pet_type_list: roomDto.pet_type_list,
        room_units: roomDto.room_units.map(unit => convertToRoomUnit(unit)),
        room_rules: roomDto.room_rules.map(rule => convertToRoomRule(rule)),
        restrictedCatBreedList: roomDto.restriction_cat_breed_list,
        restrictedDogBreedList: roomDto.restriction_dog_breed_list,
        restrictedPetTagList: roomDto.restriction_pet_tag_list,
        staffIds: roomDto.staff_ids ?? []
    };
};

export const convertToRoomUnit = (roomUnitDto: RoomUnitDto): RoomUnit => {
    return {
        id: roomUnitDto.id,
        uuid: roomUnitDto.uuid,
        name: roomUnitDto.name,
        active: roomUnitDto.active ?? true,
        available: roomUnitDto.available,
        occupancy: roomUnitDto.occupancy ?? 0,
        activeSizeRuleId: roomUnitDto.active_size_rule_id ?? null,
        sizeEligibility:
            typeof roomUnitDto.size_eligibility === 'string'
                ? parseJSON(roomUnitDto.size_eligibility, null)
                : roomUnitDto.size_eligibility ?? null
    };
};

export const convertToRoomRule = (roomRuleDto: RoomDto['room_rules'][number]): RoomRule => {
    return {
        id: roomRuleDto.id,
        uuid: roomRuleDto.uuid,
        description: roomRuleDto.description,
        ruleTypeId: roomRuleDto.rule_type_id as RoomRule['ruleTypeId'],
        ruleData: parseJSON(roomRuleDto.rule_data, {}) as RoomRuleData,
        rawRuleData: roomRuleDto.rule_data
    };
};
